import { render, staticRenderFns } from "./newsletterF.vue?vue&type=template&id=ff1a50b8"
import script from "./newsletterF.vue?vue&type=script&lang=js"
export * from "./newsletterF.vue?vue&type=script&lang=js"
import style0 from "./newsletterF.vue?vue&type=style&index=0&id=ff1a50b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports